<template>
  <section>
    <ul class="filters-list">
      <li>
        <router-link
          :to="{
            name: 'AllCases',
            query: this.$route.query,
          }"
          active-class=""
          :class="{ 'router-link-active': $route.name === 'AllCases' }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveCases',
            query: this.$route.query,
          }"
        >
          ACTIVE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="hasPermission('cases', 'cases_filters_view')">
        <router-link
          :to="{
            name: 'PendingCases',
            query: this.$route.query,
          }"
        >
          PROCESSING
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'CompleteCases',
            query: this.$route.query,
          }"
        >
          FINALIZED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="hasPermission('cases', 'cases_filters_add_new')">
        <router-link
          :to="{
            name: 'ArchiveCase',
            query: this.$route.query,
          }"
        >
          ARCHIVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'RejectedCases',
            query: this.$route.query,
          }"
        >
          REJECTED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li
        v-if="hasPermission('cases_filters', 'view') && checkLab"
        v-loading="loading"
      >
        <router-link
          :to="{
            name: 'CriticalCases',
            query: this.$route.query,
          }"
        >
          CRITICAL
          {{
            this.getCriticalCounts
              ? "(" + (this.getCriticalCounts.count || 0) + ")"
              : "(" + "0" + ")"
          }}
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" />
          </span>
        </router-link>
      </li>
      <li v-if="showCrossLabRegisteredCases">
        <router-link
          class="cross-lab-link"
          :title="crossLabRegisteredLabel"
          :to="{
            name: 'CrossLabRegisteredCases',
            query: this.$route.query,
          }"
        >
          {{ crossLabRegisteredLabel }}
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <!-- <li>
        <router-link
          :to="{
            name: 'RequiresAttentionCases',
            query: this.$route.query,
          }"
        >
          REQUIRES ATTENTION
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
      <li>
        <router-link
          :to="{
            name: 'FaxNotSentCases',
            query: this.$route.query,
          }"
        >
          UNFAXED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <!-- <li v-if="isSuperAdmin">
        <router-link
          :to="{
            name: 'FaxInProcessCases',
            query: this.$route.query,
          }"
        >
          FAX IN PROCESS
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
      <li>
        <router-link
          class="tat-filter-link"
          :to="{
            name: 'TatCrossedCases',
            query: this.$route.query,
          }"
        >
          TAT
          <span v-if="tatCasesCount > 0" class="tat-count-badge">{{ tatCasesCount }}</span>
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
            <li>
        <router-link
          :to="{
            name: 'SamplesReceived',
            query: this.$route.query,
          }"
        >
          SR
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          class="priority-filter-link"
          title="Priority Release"
          :to="{
            name: 'PriorityCases',
            query: this.$route.query,
          }"
        >
          PR
          <span
            class="priority-count-badge"
            :class="{ 'is-zero': priorityCasesCount === 0 }"
            >{{ priorityCasesCount }}</span
          >
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          title="Insurance Exception"
          :to="{
            name: 'InsuranceExceptionCases',
            query: this.$route.query,
          }"
        >
          INS EXCEP
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="!isBillingUser">
        <router-link
          :to="{
            name: 'ReplacedInsurance',
            query: this.$route.query,
          }"
        >
          REPLACED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import GlobalHelper from "@/mixins/GlobalHelper";
import { mapGetters } from "vuex";
export default {
  mixins: [UserPermissionsHelper, GlobalHelper],
  computed: {
    ...mapGetters("cases", [
      "getCriticalCounts",
      "getTatCasesCount",
      "getPriorityCasesCount",
    ]),

    ...mapGetters("auth", ["getUserAllowedLabs", "getUserPrimaryLabId"]),
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && (matchedLab.lab_code == "DLW-TX" || matchedLab.lab_code == "DLW-HOU" || matchedLab.lab_code == "DLW")) {
          return true;
        }
        return false;
      }
      return false;
    },
    showCrossLabRegisteredCases() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && (matchedLab.lab_code == "DLW-TX" || matchedLab.lab_code == "DLW-HOU" )) {
          return true;
        }
      }
      return false;
    },
    tatCasesCount() {
      return this.getTatCasesCount || 0;
    },
    crossLabRegisteredLabel() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code === "DLW-HOU") {
          return "CROSS LAB CASES";
        }
      }
      return "CROSS LAB CASES";
    },
    priorityCasesCount() {
      return this.getPriorityCasesCount || 0;
    },
  },
  mounted() {
    // TAT and Priority counts are static enough that we only need them once on
    // mount — they should NOT re-fire on every status/route change.
    this.fetchTatCasesCount();
    this.fetchPriorityCasesCount();
    if (this.checkLab) {
     this.fetchAllCriticalCasesCount();
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async fetchAllCriticalCasesCount() {
      try {
        this.loading = true;
        let params = {
          is_critical : true,
          is_resolved :false
        }
        await this.$store.dispatch("cases/fetchCriticalCasesCount",params);
        this.loading = false;
      } catch (err) {}
    },
    fetchTatCasesCount() {
      this.$store.dispatch("cases/fetchTatCasesCount");
    },
    fetchPriorityCasesCount() {
      this.$store.dispatch("cases/fetchPriorityCasesCount");
    },
  },
  watch: {
    $route() {
      // Only the critical-cases count is route/status dependent. TAT and
      // Priority counts are fetched once on mount to avoid redundant calls.
      if (this.checkLab) {
        this.fetchAllCriticalCasesCount();
      }
    },
  },
};
</script>

<style scoped>
.tat-filter-link {
  position: relative;
}

/* Single-word cross-lab tab label; keep it compact so it doesn't widen the tab bar. */
.cross-lab-link {
  white-space: nowrap;
}

.tat-count-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  /* background: #273480; */
  background: #c13740;
  border-radius: 999px;
}

.priority-filter-link {
  position: relative;
}

/* Count pill sits on the top-right corner of the tab (same as TAT) — amber
   when there are priority cases, muted grey when zero. */
.priority-count-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  background: #e6a23c;
  border-radius: 999px;
}
.priority-count-badge.is-zero {
  background: #c0c4cc;
}
</style>
